import { CollectionViewer,DataSource} from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AccessControlService} from 'src/app/services/access-control.service';

export class ClientListingDataSource implements DataSource<any>{
  private clientsSubject=new BehaviorSubject<any>([])
  private clientsLoadingSubject=new BehaviorSubject<boolean>(false)
  isLoading=this.clientsLoadingSubject.asObservable()
  totalUsers=0
  constructor(private accessControlService:AccessControlService){}
  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.clientsSubject.asObservable()
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.clientsSubject.complete()
    this.clientsLoadingSubject.complete()
  }
  getOrganizationClients(orgId,pageNumber,pageSize,sortField,sortType,searchText) {
    this.clientsLoadingSubject.next(true)
    this.accessControlService.getOrganizationClients(orgId,pageNumber,pageSize,sortField,sortType,searchText)
    .pipe(
      catchError(()=>of([])),
      finalize(()=>this.clientsLoadingSubject.next(false))
    )
    .subscribe((res:any) => {
      this.totalUsers=res.totalUsers
      this.clientsSubject.next(res.data)
    })
  }
}
